module.exports = __webpack_public_path__ + "media/stylesheets/images/main/rank/top4-080e206fa98e1df28c5fec305f3ea490.svg";